import { directoryQueryPlan } from '@mts/shared/publicSeoRoutes';
import { useInitialPublicData } from '../seo/PublicBootstrap.jsx';
import { useEffect, useState } from 'react';
import { mapListingToCardListing } from './useDirectorySearchState.js';
import { requestPublicJson } from '../services/api.js';

export function useDirectoryListings(params) {
  const { query, invalid } = directoryQueryPlan(params);
  const key = query.toString();
  const initial = useInitialPublicData("directory");
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState(initial ? { key, listings: initial.listings.map(mapListingToCardListing), total: initial.total, loading: false, error: null } : { key: null, listings: [], total: 0, loading: true, error: null });
  useEffect(() => {
    if (invalid) { setState({ key, listings: [], total: 0, loading: false, error: 'Choose valid directory filters.' }); return undefined; }
    if (initial && attempt === 0) {
      setState({ key, listings: initial.listings.map(mapListingToCardListing), total: initial.total, loading: false, error: null });
      return undefined;
    }
    let active = true;
    setState({ key, listings: [], total: 0, loading: true, error: null });
    requestPublicJson(`/api/directory/businesses?${key}`)
      .then(data => {
        if (active) setState({ key, listings: data.listings.map(mapListingToCardListing), total: data.total, loading: false, error: null });
      })
      .catch(error => {
        if (active) setState({ key, listings: [], total: 0, loading: false, error: error.message });
      });
    return () => { active = false; };
  }, [key, attempt, initial, invalid]);
  const current = state.key === key ? state : { listings: [], total: 0, loading: true, error: null };
  return { ...current, retry: () => setAttempt(value => value + 1) };
}
